import { combineReducers } from "redux"
import i18n from "./i18n/I18NReducer"
import plans from "./plans/PlansReducer"
import { VGReducers } from "react-visioglobe"

const reducers = combineReducers({
  i18n,
  plans,
  vg: (state, action) => {
    if (action && action.type === "VGACTIONS_PLACE") {
      return state
    }
    return VGReducers.vg(state, action)
  }
})

export default reducers



// WEBPACK FOOTER //
// ./src/store/reducers.js